import { getConfig } from '@constants';

import { EStatEventType, EAppId } from '../../../../enums';
import { StatInstanceBase } from '../../StatInstanceBase';

export class StatBoomApi extends StatInstanceBase {

	private getAppId(): EAppId {
		return getConfig().isMobile ? EAppId.WEB_MOBILE : EAppId.WEB;
	}

	openBoomLanding() {
		void this.sendStat({
			action: EStatEventType.BOOM_LANDING_OPEN,
			appId: this.getAppId(),
		});
	}

	openBoomBrand() {
		void this.sendStat({
			action: EStatEventType.BOOM_BRAND_OPEN,
			appId: this.getAppId(),
		});
	}

	downloadBoomBrand() {
		void this.sendStat({
			action: EStatEventType.BOOM_BRAND_DOWNLOAD,
			appId: this.getAppId(),
		});
	}

	downloadAllBoomBrand() {
		void this.sendStat({
			action: EStatEventType.BOOM_BRAND_DOWNLOAD_ALL,
			appId: this.getAppId(),
		});
	}

	openBoomDmca() {
		void this.sendStat({
			action: EStatEventType.BOOM_DMCA_OPEN,
			appId: this.getAppId(),
		});
	}

	submitBoomDmca() {
		void this.sendStat({
			action: EStatEventType.BOOM_DMCA_SUBMIT,
			appId: this.getAppId(),
		});
	}

	uploadFileForBoomDmca() {
		void this.sendStat({ action: EStatEventType.BOOM_DMCA_UPLOAD_FILE });
	}

	uploadFileSuccessForBoomDmca() {
		void this.sendStat({ action: EStatEventType.BOOM_DMCA_UPLOAD_FILE_SUCCESS });
	}

	uploadFileCancelledForBoomDmca() {
		void this.sendStat({ action: EStatEventType.BOOM_DMCA_UPLOAD_FILE_CANCELLED });
	}

	uploadFileErrorForBoomDmca(error: Error) {
		void this.sendStat({
			action: EStatEventType.BOOM_DMCA_UPLOAD_FILE_ERROR,
			data0: error.message || '',
		});
	}

	showSuccessForBoomDmca() {
		void this.sendStat({
			action: EStatEventType.BOOM_DMCA_SUCCESS,
			appId: this.getAppId(),
		});
	}

	showErrorForBoomDmca() {
		void this.sendStat({
			action: EStatEventType.BOOM_DMCA_ERROR,
			appId: this.getAppId(),
		});
	}

}
